// extracted by mini-css-extract-plugin
module.exports =  {"container":"Ob53H3iN9dyY9DYDmpFW"};